
// ============================================================
// 逻辑部分完全保留原始代码，未做任何功能删减
// ============================================================
import { Component, Vue, Ref } from 'vue-property-decorator'
import { UserService, ContactService } from '@/services/index'
import { NIUMEI_HOST, NIUMEI_TEST_HOST } from '@/config/env'
import SearchLog from './components/searchLog.vue'
import OperationLog from './components/operationLog.vue'
import NoData from '@/components/no_data/index.vue'
import Contact from './components/contact.vue'
import Memo from './components/memo.vue'
import ContactTable from './components/contactTable.vue'
import BehaviorPath from './components/behaviorPath.vue'
import ReportList from './components/reportList/index.vue'
import RelatedReporterDialog from './components/related_reporter/index.vue'

enum IdentityMap {
    Media = 0,
    Pr = 1,
    Expert = 2,
    Other = 3
}

@Component({
    name: 'UserDetail',
    components: {
        SearchLog,
        OperationLog,
        NoData,
        Contact,
        Memo,
        ContactTable,
        BehaviorPath,
        ReportList,
        RelatedReporterDialog
    }
})
export default class extends Vue {
    private userId = ''
    private curTab: string = 'authInfo'
    private user: any = {}
    private query: any = ''
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0
    private contactPageIndex = 1
    private contactPageSize = 15
    private contactPageTotal = 0
    private contacts = []
    private searchLogs = []
    private loading = true
    private innerLoading = false
    private contactLoading = false
    private memoLoading = false
    private isEditSettleCIdVisible = false
    private contactType = 'contact'
    private identities = [
        { key: 0, name: '媒体人' },
        { key: 1, name: '品牌方/政务人士' },
        { key: 2, name: '专家学者' },
        { key: 3, name: '线人/其他' }
    ]
    private mapVipLevel = [
        { key: 0, name: '普通用户' },
        { key: 3, name: 'VIP' },
        { key: 1, name: '高级VIP' },
        { key: 2, name: '超级VIP' }
    ]
    private mapCertStatus: any = {
        0: '未认证',
        1: '申请认证中',
        2: '认证成功',
        3: '认证失败'
    }
    private mapPlatform: any = {
        1: 'PC',
        2: 'H5',
        3: 'APP',
        4: '微信小程序'
    }
    private certStatus: any = {
        unAuth: 0,
        authPedding: 1,
        authSuccess: 2,
        authError: 3
    }
    @Ref('contact') private contactRef: any
    @Ref('memo') private memoRef: any

    get isMedia() {
        return this.user.identity === IdentityMap.Media
    }
    get relateReporterEl() {
        return this.$refs.relateReporterRef as any
    }

    private mounted() {
        this.userId = this.$route.params.id
        if (this.$route.query.tab) {
            this.curTab = this.$route.query.tab as string
            if (this.curTab === 'searchLogs') {
                this.getSearchLogs()
            } else if (this.curTab === 'contactLogs') {
                this.getContactLogs()
            }
        }
        this.getUser()
    }

    private async getUser() {
        this.$title('Loading | 用户详情 - 庖丁')
        const result = await UserService.getNmUser({ id: this.userId })
        this.loading = false
        if (result.status === 200) {
            this.user = result.data
            this.$title(`${this.user.name} | 用户详情 - 庖丁`)
        }
    }

    private async getSearchLogs() {
        this.innerLoading = true
        const params = {
            user_id: this.userId,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await UserService.getNmUserSLogs(params)
        this.innerLoading = false
        if (result.status === 200) {
            this.searchLogs = result.data.logs
            this.pageTotal = result.data.page_total
        }
    }

    private async blockUser() {
        const result = await UserService.blockNmUser({ id: this.userId })
        if (result.status === 200) {
            this.user.disabled = true
            this.$msuccess('封号成功')
        }
    }

    private async unBlockUser() {
        const result = await UserService.unBlockNmUser({ id: this.userId })
        if (result.status === 200) {
            this.user.disabled = false
            this.$msuccess('解禁成功')
        }
    }

    private async onLinkReporter(reporter: any) {
        const params = { user_id: this.userId, reporter_id: reporter.id }
        const result = await UserService.updateNmUser(params)
        this.relateReporterEl.close()
        if (result.status === 200) {
            this.getUser()
            return this.$msuccess('关联成功')
        }
    }

    private async onRemoveLinkRep() {
        const msg =
            '是否取消用户【' +
            this.user.name +
            '】和' +
            this.user.reporter.name +
            '的关联?'
        this.$confirm(msg, '取消关联', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        })
            .then(async () => {
                const params = { user_id: this.userId, reporter_id: 0 }
                const result = await UserService.updateNmUser(params)
                if (result.status === 200) {
                    this.getUser()
                    return this.$msuccess('取消关联成功')
                }
            })
            .catch(() => {})
    }

    private async onPass() {
        const params = {
            user_id: this.userId,
            cert_status: this.certStatus.authSuccess
        }
        const result = await UserService.updateNmUser(params)
        if (result.status === 200) {
            this.getUser()
            return this.$msuccess('通过成功')
        }
    }

    private async onReject() {
        this.$confirm('确定驳回认证？', '驳回认证', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        })
            .then(async () => {
                const params = {
                    user_id: this.userId,
                    cert_status: this.certStatus.authError
                }
                const result = await UserService.updateNmUser(params)
                if (result.status === 200) {
                    this.getUser()
                    return this.$msuccess('驳回成功')
                }
            })
            .catch(() => {})
    }

    private async onCancel() {
        this.$confirm('确定取消认证？', '取消认证', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        })
            .then(async () => {
                const params = {
                    user_id: this.userId,
                    cert_status: this.certStatus.authError
                }
                const result = await UserService.updateNmUser(params)
                if (result.status === 200) {
                    this.getUser()
                    return this.$msuccess('取消成功')
                }
            })
            .catch(() => {})
    }

    private async createApply() {
        const params = { nm_user_id: this.user.id }
        const result = await UserService.createPhoneApply(params)
        if (result.status === 200) {
            return this.$msuccess('提交申请成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }

    private onSwitchTab(tab: any) {
        this.curTab = tab.name
        if (this.curTab === 'searchLogs') {
            this.getSearchLogs()
        } else if (this.curTab === 'contactLogs') {
            this.getContactLogs()
        }
        const url = this.$route.path + `?tab=${this.curTab}`
        history.pushState('', '', url)
    }

    private onShowLinkRepDig() {
        this.relateReporterEl.show({
            name: this.user.name
        })
    }

    private onBlockUser() {
        this.$confirm(
            '封号以后用户不能再正常使用，是否确定封禁此账号？',
            '确认',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                center: true
            }
        )
            .then(() => {
                this.blockUser()
            })
            .catch(() => {})
    }

    private onUnBlockUser() {
        this.$confirm(
            '是否解禁此账号，解禁后此用户可以正常使用',
            '确认',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                center: true
            }
        )
            .then(() => {
                this.unBlockUser()
            })
            .catch(() => {})
    }

    private onApplyPhone() {
        this.$confirm(
            `你正在申请查看用户 ${this.user.name} 的手机号, 是否确认申请?`,
            '提示',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }
        ).then(() => {
            this.createApply()
        })
    }

    private onCurrentChange(page: any) {
        this.pageIndex = page
        this.getSearchLogs()
    }

    private onContact() {
        (this.contactRef as any).show()
    }

    private onCreateMemo() {
        (this.memoRef as any).show()
    }

    private async onContactSend(form: any) {
        const params = {
            user_id: this.userId,
            content: form.content,
            type: form.sendType
        }
        this.contactLoading = true
        const result = await UserService.sendMesaageToUser(params)
        this.contactLoading = false
        if (result.status === 200) {
            (this.contactRef as any).close()
            this.getUser()
            return this.$msuccess('发送成功')
        }
    }

    private async getContactLogs() {
        this.innerLoading = true
        const params = {
            user_id: this.userId,
            page_index: this.contactPageIndex,
            page_size: this.contactPageSize
        }
        const result = await ContactService.getContactLogs(params)
        this.innerLoading = false
        if (result.status === 200) {
            this.contactPageTotal = result.data.pageTotal
            this.contacts = result.data.list
        }
    }

    private async onMemoSet({ memo }: any) {
        const params = {
            user_id: this.userId,
            memo
        }
        this.memoLoading = true
        const result = await UserService.updateNmUser(params)
        this.memoLoading = false
        if (result.status === 200) {
            (this.memoRef as any).close()
            this.getUser()
            return this.$msuccess('设置备注成功')
        }
    }

    private onGoNiumei() {
        const path = 'reporter/' + this.user.reporter.id
        if (location.host === 'pd.media.beer') {
            window.open(NIUMEI_HOST + path)
        } else {
            window.open(NIUMEI_TEST_HOST + path)
        }
    }

    private onContactPageChange(curPage: number) {
        this.contactPageIndex = curPage
        this.getContactLogs()
    }

    private onIdentityChange(identity: number) {
        this.$confirm('你正在更改用户身份, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.updateUserIdentity(identity)
        })
    }

    private onVipLevelChange(vipLevel: number) {
        this.$confirm('你正在更改用户等级, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.updateUserLevel(vipLevel)
        })
    }

    private async updateUserLevel(vipLevel: number) {
        const params = {
            user_id: this.userId,
            vip_level: vipLevel
        }
        const result = await UserService.updateUserLevel(params)
        if (result.status === 200) {
            this.user.vip_level = vipLevel
            return this.$msuccess('修改成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }

    private async updateUserIdentity(identity: number) {
        const params = {
            user_id: this.userId,
            identity: identity
        }
        const result = await UserService.updateNmUser(params)
        if (result.status === 200) {
            this.user.identity = identity
            return this.$msuccess('修改成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }

    private async onSaveSettleCId() {
        const params = {
            user_id: this.userId,
            pr_company_id: this.user.pr_company_id
        }
        const result = await UserService.updateNmUser(params)
        if (result.status === 200) {
            this.isEditSettleCIdVisible = false
            return this.$msuccess('修改成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
}
